// extracted by mini-css-extract-plugin
export default {"AssessmentInfo":"styles_AssessmentInfo__mOibr","row":"styles_row__Pd3P-"};